/// <reference path="FilterPanelTypes.ts" />
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FilterPanelSection.html?raw';
import on from 'dojo/on';

import FilterPanelOption from './FilterPanelOption';
import "./FilterPanelOption";
//import FilterPanelOption = require("./FilterPanelOptionV2");
//import "./FilterPanelOptionV2";
//import FilterPanel = require("./FilterPanel");
//import "./FilterPanel";
//import DataItems = require("DataItems");

// interfaces für die Daten:
import "./FilterPanelTypes";

import { FilterPanelTypes, FilterPanelFormat, FilterOptionTypes } from "../../../moreCore/UI/FilterPanel/FilterPanelTypes";
import { TranslationHelpers } from "../../../more/Helpers";
class FilterPanelSection extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private headerBarNode: HTMLDivElement;
    private headerTitleRow: HTMLElement;
    private headerTitle: HTMLSpanElement;
    private filterOptionsContainer: HTMLDivElement;
    private collapseIcon: HTMLElement;
    private collapseContainer: HTMLElement;
    private txtInfo: HTMLElement;

    private warningIcon: HTMLElement;
    private leftIconNode: HTMLElement;
    private sectionControlContainer: HTMLElement;
    private btnSetInvisible: HTMLElement;
    private btnMoveNext: HTMLElement;
    private btnMovePrevious: HTMLElement;
    private debugOrder: HTMLElement;
    //btnSubmit: HTMLButtonElement;
    //buttonContainer: HTMLElement;
    //buttonLabel: HTMLElement;

    filterOptions: Array<MdsLax<InstanceType<typeof FilterPanelOption>>>;
    //private panel: FilterPanel;
    private sectionData: FilterPanelTypes.SectionConfig;
    name: string = "";
    private rules: FilterPanelTypes.SectionRules;
    valid: boolean = true;

    private _jsonData: object;
    private _jsonDataCompact: object;

    private isReadonly: boolean = false;
    private _isCollapsed: boolean = false;
    private isCollapsible: boolean = false;
    private isHideable: boolean = false;
    private _isHidden: boolean = false;
    private _order: number = 0;
    private _orderByUser: number = 0;
    private _moveable: boolean = false;

    private _updateTimeoutHandle: any = null;

    private hideWarningIcon: boolean = true;

    getData(format: FilterPanelFormat = FilterPanelFormat.compact, bForceIfInvalid?: boolean): object {
        if (this.valid != true && bForceIfInvalid !== true) {
            return null;
        }

        if (!this._jsonData) {
            this.serializeData(true, bForceIfInvalid);
        }


        switch (format) {
            case FilterPanelFormat.default:
                return this._jsonData;
                break;

            case FilterPanelFormat.compact:
            default:
                return this._jsonDataCompact;
                break;

        }

        return this._jsonData;
    }
    setSortingAllowed(allowed: boolean = true) {
        
        this.UiModder.domClass.toggle(this.domNode, "moveable", allowed === true);
        this._moveable = allowed;
    }
    setFilterOptions(filteroptions: Array<FilterPanelTypes.OptionConfig>): void {

        this.filterOptions = [];

        if (typeof (filteroptions) != "undefined" && filteroptions != null) {
            for (let i = 0; i < filteroptions.length; i++) {
                let filteroption: FilterPanelTypes.OptionConfig = filteroptions[i];
                this.addFilterOption(filteroption);
                //filteroption. this.sectionData.name + filteroption.name
            }
        }
    }

    setReadonly(bValue?: boolean) {
        if (bValue !== true && bValue !== false) {
            bValue = true;
        }

        this.isReadonly = bValue;

        for (let option of this.filterOptions) {
            option.setReadonly(this.isReadonly);
        }
    }

    setInfoText(text: string) {
        if (TranslationHelpers.canTranslate(text)) text = TranslationHelpers.translate(text);

        this.hideNode(this.txtInfo.parentElement, !text);
        this.UiModder.domAttr.set(this.txtInfo, "innerHTML", text);
    }

    private _setHeaderAttr(value: string): void {

        if (TranslationHelpers.canTranslate(value)) value = TranslationHelpers.translate(value);

        this.UiModder.domAttr.set(this.headerTitle, "innerHTML", value);

        if (!value || value == "") {
            this.hideNode(this.headerTitle);
            this.hideWarningIcon = true;
        } else {
            this.hideNode(this.headerTitle, false);
            this.hideWarningIcon = false;
        }
    }

    private _setRulesAttr(value: FilterPanelTypes.SectionRules): void {
        this.rules = value;
    }
    private _setVisibilityControlAttr(isHideable: boolean, visible: boolean = true, bSuppressChangeemit: boolean = false) {
        //this.isHideable = isHideable;
        this.isHideable = false;
        this.UiModder.domClass.toggle(this.btnSetInvisible, "w3-hide", !this.isHideable);
        this.setInvisible(this.isHideable && visible != true, bSuppressChangeemit);
    }

    setCollapsible(isCollapsible?: boolean, isCollapsed?: boolean, bSuppressChangeemit: boolean = false) {
        this._setCollapsibleAttr(isCollapsible, isCollapsed, bSuppressChangeemit);
    }
    private _setCollapsibleAttr(isCollapsible?: boolean, isCollapsed?: boolean, bSuppressChangeemit: boolean = false) {
        if (isCollapsible != true && isCollapsible != false) {
            isCollapsible = true;
        }

        if ((isCollapsed != true && isCollapsed != false) || isCollapsible != true) {
            isCollapsed = false;
        }

        this.isCollapsible = isCollapsible;
        this._isCollapsed = isCollapsed;
        this.setCollapseStyle();

        if (bSuppressChangeemit != true) {
            this.emit("collapsed", this._isCollapsed);
        }
    }

    /**
     * Gibt zurück, ob die Section collapsed (zugeklappt) ist.
     */
    getCollapseState(): boolean {
        if (this.isCollapsible) {
            return this._isCollapsed == true;
        }

        return false;
    }

    getVisibility(): boolean {
        if (this.isHideable) {
            if (this._isHidden) return false;
        }

        return true;
    }

    private _onClickCollapse(evt: MouseEvent) {
        if (this.isCollapsible != true) {
            return;
        }

        if (this._isCollapsed == true) {
            this.expand();
        } else {
            this.collapse();
        }

    }

    private setCollapseStyle() {
        if (this.isCollapsible === true) {
            this.UiModder.domClass.remove(this.collapseContainer, "w3-hide");
            this.UiModder.domClass.add(this.headerTitleRow, "mds-text-hover-bright");
        } else {
            this.UiModder.domClass.add(this.collapseContainer, "w3-hide");
            this.UiModder.domClass.remove(this.headerTitleRow, "mds-text-hover-bright");
        }

        if (this._isCollapsed == true) {
            //this.UiModder.domClass.remove(this.collapseIcon, "fa-chevron-circle-up");
            this.UiModder.domClass.remove(this.collapseIcon, "fa-rotate-90");

            this.UiModder.domClass.add(this.filterOptionsContainer, "w3-hide");
            this.UiModder.domClass.add(this.domNode, "collapsed");


        } else {
            //this.UiModder.domClass.add(this.collapseIcon, "fa-chevron-circle-up");
            this.UiModder.domClass.add(this.collapseIcon, "fa-rotate-90");

            this.UiModder.domClass.remove(this.filterOptionsContainer, "w3-hide");
            this.UiModder.domClass.remove(this.domNode, "collapsed");
        }
    }

    collapse() {
        if (this._isCollapsed === true) return;

        this._isCollapsed = true;
        this.setCollapseStyle();

        this.emit("collapsed", this._isCollapsed);
        
    }

    expand() {
        if (this._isCollapsed != true) return;

        this._isCollapsed = false;
        this.setCollapseStyle();

        this.emit("collapsed", this._isCollapsed);

    }

    setOrder(order: number = 1, bEmitOrderChange: boolean = false) {
        this._setOrderAttr(order, bEmitOrderChange);
    }
    private _setOrderAttr(order: number = 1, bEmitOrderChange: boolean = false) {
        if (typeof (order) != "number") return;

        let bOrderIncrease: boolean = false;
        if (order > this._orderByUser) bOrderIncrease = true;

        this._orderByUser = order;
        this.UiModder.domStyle.set(this.domNode, "order", (this._order + this._orderByUser));
        this.UiModder.domAttr.set(this.debugOrder, "innerHTML", this._orderByUser.toString() + " + " + this._order.toString());

        if (bEmitOrderChange) {
            if (bOrderIncrease) {
                this.emit("orderUp", this._order);
            } else {
                this.emit("orderDown", this._order);
            }
        }
    }

    getOrder(calculateDisplayFlags: boolean = false): number {
        let order = this._orderByUser;

        if (calculateDisplayFlags) {
            if (this._isHidden === true) order = order + 999;

            if (this._isCollapsed === true) order = order - 9999;
        }
        return order;
    }

    setSectionData(data: FilterPanelTypes.SectionConfig): void {
        //console.debug("setSectionData", data);
        this.sectionData = data;

        this.name = data.name;
        
        if (data) {
        
            this._setHeaderAttr(data.sectionLabel);
            this._setRulesAttr(data.rules);

            if (data.widthLarge) {
                this.UiModder.domClass.add(this.domNode, "w3-col");
                this.UiModder.domClass.add(this.domNode, data.widthLarge);
            }

            if (data.widthMedium) {
                this.UiModder.domClass.add(this.domNode, "w3-col");
                this.UiModder.domClass.add(this.domNode, data.widthMedium);
            }

            if (data.widthSmall) {
                this.UiModder.domClass.add(this.domNode, "w3-col");
                this.UiModder.domClass.add(this.domNode, data.widthSmall);
            }

            if (data.infoText) {
                this.setInfoText(data.infoText);
            }

            this._setCollapsibleAttr(data.collapsible, data.isCollapsed, true);
            this._setVisibilityControlAttr(data.hideable, data.visibleByDefault, true);

            if (data.options) {
                for (let option of data.options) {
                    this.addFilterOption(option);
                }
            }

            if (typeof (data.order) == "number") {
                //this._setOrderAttr(data.order);
                this._order = data.order;
            }
        }

        this.serializeData();
    }

    private _onKeyUp_Option(evt: KeyboardEvent) {
        this.emit("keyUp", evt);
    }
    addFilterOption(optionData: FilterPanelTypes.OptionConfig): MdsLax<InstanceType<typeof FilterPanelOption>> {
        let isDynamicOption = false;
        let option: MdsLax<InstanceType<typeof FilterPanelOption>> = new FilterPanelOption();

        on(option, "keyUp", lang.hitch(this, this._onKeyUp_Option));

        //if (data.type == FilterOptionTypes.multiselect) debugger;

        option.setData(optionData);
        option.section = this;

        //option.set("name", data.name);
        //option.set("label", data.label);
        //option.set("type", data.type);
        //option.set("value", data.value);
        //option.set("selected", data.selected === true);
        //option.set("mandatory", data.isMandatory === true);

        // dynamisch?
        if (this.sectionData.updateFunction && this.sectionData.leadingOptions) {
            isDynamicOption = this.sectionData.leadingOptions.indexOf(optionData.name) != -1;
        }
        if (isDynamicOption) {

            option.domNode.classList.add("leading");
            //this.UiModder.domConstruct.place(option.domNode, this.filterLeadingOptionsContainer);
            //this.hideNode(this.filterLeadingOptionsContainer, false);

            //on(option, "valueChanged", lang.hitch(this, this._handleDynamicSectionUpdateDelayed));

        }

        // If not "leading" just act normal
        this.UiModder.domConstruct.place(option.domNode, this.filterOptionsContainer);

        this.filterOptions.push(option);

        on(option, "valueChanged", lang.hitch(this, this._onChange_OptionValue));
        on(option, "change", lang.hitch(this, this._onChange_OptionState, option));

        this._syncOptionWidths(10);

        return option;
    }

    private _onChange_OptionValue(bSuppressChangeEmit?: boolean, bForceIfInvalid?: boolean) {

        this.serializeData(bSuppressChangeEmit, bForceIfInvalid);
    }

    private _previousOptionStateData: string;
    private _onChange_OptionState(option: MdsLax<InstanceType<typeof FilterPanelOption>>) {
        let optionData = option.getData();
        let emitData: FilterPanelTypes.ValueChangeNotice = {
            name: this.name,
            option: optionData.name,
            optionValue: optionData.value as any,
            toggleSelected: optionData.selected
        }
        this.emit("valueChange", emitData);

        this._syncOptionWidths();

        // dynamisch?
        let isDynamicOption = false;
        if (this.sectionData.updateFunction && this.sectionData.leadingOptions) {
            isDynamicOption = this.sectionData.leadingOptions.indexOf(optionData.name) != -1;
        }
        if (isDynamicOption) {
            this._handleDynamicSectionUpdateDelayed();
        }
    }

   

    private _handleDynamicSectionUpdateDelayed(delay?: number): void {
        if (this._updateTimeoutHandle != null) {
            clearTimeout(this._updateTimeoutHandle);
            this._updateTimeoutHandle = null;
        }

        if (typeof (delay) == "undefined" || delay < 0) delay = 800;

        this._updateTimeoutHandle = setTimeout(lang.hitch(this, this._loadDynamicSectionUpdate), delay);
    }

    private _loadDynamicSectionUpdate() {


        let sectionData = this.getData(FilterPanelFormat.compact, true);

        let data = {
            sectionName: this.sectionData.name,
            updateFunction: this.sectionData.updateFunction,
            sections: [sectionData]
        };
        
        this.disableNode(this.filterOptionsContainer, false);

        this.hourGlassStart(this.filterOptionsContainer);
        this.RequestManager.callfunction(
            "Webtool_API_FilterPanel__GetSectionUpdate",
            data,
            lang.hitch(this, this._onUpdateSectionState_Response),
            (err) => {
                this.showToast(err.Message);
                this.hourGlassEnd(this.filterOptionsContainer);
            }
        )

    }
    private _onUpdateSectionState_Response(response: FilterPanelTypes.DynamicSectionUpdate) {

        for (let key in response.updateresult) {
            let option = this.getFilterOptionByName(key);
            if (option) {
                option.updateData(response.updateresult[key]);
            }
        }
        this._syncOptionWidths(10);
        this.hourGlassEnd(this.filterOptionsContainer);
    }


    serializeData(bSuppressChangeEmit?: boolean, bForceIfInvalid?: boolean): void {
        //console.debug(this.id + " serializeData", this.filterOptions);

        let json = { name: this.name, options: [] };
        let bValid = true;
        let selectedCount = 0;

        let compactJson = { "_sectionName": this.name };

        for (let i = 0; i < this.filterOptions.length; i++) {
            let option = this.filterOptions[i];

            if (option.selected == true || option.alternativeMandatoryMode == true) {
                if (option.valid != true) {
                    bValid = false;
                } else {
                    selectedCount++;
                }

                let data = option.getData();
                //console.debug("detail serializeData", data);
                json.options.push(data);

                if (data.selected || option.alternativeMandatoryMode == true) {
                    compactJson[data.name] = data.value;
                } else {
                    delete compactJson[data.name];
                }
            }
        }
        
        // weitere Regeln prüfen!
        if (this.rules != null) {
            if (typeof (this.rules.minSelectedCount) != "undefined") {
                if (selectedCount < this.rules.minSelectedCount) {
                    bValid = false;
                }
            }

            if (typeof (this.rules.maxSelectedCount) != "undefined") {
                if (selectedCount > this.rules.maxSelectedCount) {
                    bValid = false;
                }
            }
        }

        this.valid = bValid;
        let disabledClasses = "";
        let enabledClasses = "";

        this.UiModder.domClass.toggle(this.domNode, "invalid", !bValid);
       
        if (bValid === true || bForceIfInvalid === true) {
            this._jsonData = json;

            this._jsonDataCompact = compactJson;

            if (bSuppressChangeEmit != true) {
                this.emit("serializedData", this._jsonDataCompact);
            }

        } else {
            if (bSuppressChangeEmit != true) {
                this.emit("serializedData", false);
            }
        }

        this.displayWarning(!bValid);
    }

    private displayWarning(bDisplay?: boolean): void {
        if (bDisplay === false) {
            this.UiModder.domClass.add(this.warningIcon, "w3-hide");
        } else {
            if (!this.hideWarningIcon) this.UiModder.domClass.remove(this.warningIcon, "w3-hide");
            this.expand();
        }
    }

    getFilterOptionValue(optionname: string): string | number | boolean | Array<string> {
        //console.debug("getFilterOptionValue", optionname, this.filterOptions);
        let filterOption = this.getFilterOptionByName(optionname);

        if (filterOption) {
            return filterOption.getValue(false);
        }
        
        return null;
    }

    getFilterOptionByName(optionname: string): MdsLax<InstanceType<typeof FilterPanelOption>> {
        for (let filterOption of this.filterOptions) {
            if (filterOption.getData().name == optionname) {
                return filterOption;
            }
        }

        return null;    
    }

    getFilterOptions(): Array<MdsLax<InstanceType<typeof FilterPanelOption>>> {
        if (!this.filterOptions?.length) return [];

        return this.filterOptions;
    }

    private __syncOptionWidthsTimeout;
    private _syncOptionWidths(timeout?: number) {

        this.domNode.style.removeProperty("--syncedSelectWidth");

        if (typeof (timeout) == "number" && timeout > 0) {
            if (this.__syncOptionWidthsTimeout) {
                clearTimeout(this.__syncOptionWidthsTimeout);
                
            }

            this.__syncOptionWidthsTimeout = setTimeout(lang.hitch(this, this._syncOptionWidths), timeout);
            return;
        }
        
        let maxWidth: number = -1;
        let warningWidth: number = -1;
        for (let option of this.filterOptions) {
            if (option.getType() != FilterOptionTypes.toggleButton) {

                let node = option["_targetSelect"];
                if (node) {
                    maxWidth = Math.max(maxWidth, node.clientWidth);
                    warningWidth = Math.max(warningWidth, option.warningNode.clientWidth); // wenns eingeblendet ist, hat es eine Breite, die wir zur Berechnung weiterverwenden
                }
            }
        }

        if (maxWidth > 10) {
            this.domNode.style.setProperty("--syncedSelectWidth", maxWidth + "px");
            this.removeSubscription("/Global/Click"); 
        } else {
            this.domNode.style.removeProperty("--syncedSelectWidth");
            // es kann sein, dass das Panel nicht ursprünglich sichtbar war (zb in Tabcontainer), dann sind wir noch ohne Ergebnis. auf den erstbesten Klick hören und nochmal versuchen
            if (maxWidth == 0) {
                this.addSubscription("/Global/Click", lang.hitch(this, this._syncOptionWidths, 5));
            }
        }
        if (warningWidth > 10) {
            this.domNode.style.setProperty("--syncedWarningWidth", warningWidth + "px");
        } else {
            this.domNode.style.removeProperty("--syncedWarningWidth");
        }

        this.__syncOptionWidthsTimeout = null;
    }

    private _onClick_MoveNext(evt: MouseEvent) {
        //if (evt) {
        //    evt.stopPropagation();
        //}
        if (!this._moveable) return;
        
        this._setOrderAttr(this._orderByUser + 105, true);
    }
    private _onClick_MovePrevious(evt: MouseEvent) {
        //if (evt) {
        //    evt.stopPropagation();
        //}
        if (!this._moveable) return;

        this._setOrderAttr(this._orderByUser - 105, true);
    }

    private _onClick_Invisible(evt: MouseEvent) {

        if (this.isHideable) {
            this.setInvisible(!this._isHidden);
        }

        if (evt) {
            evt.stopPropagation();
        }
    }

    setInvisible(target: boolean = true, bSuppressEmit: boolean = false) {
        
        //if (this.isHideable) {
        if (false) {
            this._isHidden = target;
            this.UiModder.domClass.toggle(this.domNode, "mds-fade", true);
            if (target) {
                //this.UiModder.domClass.add(this.domNode, "w3-hide hidden");
            } else {
                //this.UiModder.domClass.remove(this.domNode, "w3-hide");
                setTimeout(lang.partial(this.UiModder.domClass.remove, this.domNode, "hidden"), 10)

            }            

            if (bSuppressEmit != true) {
                this.emit("visibilityChanged", this._isHidden);
            }
        }
        else {
            this._isHidden = false;
            this.UiModder.domClass.remove(this.domNode, "w3-hide hidden mds-fade");
        }

        
    }

    postMixInProperties(args?: any): void {
            super.postMixInProperties.apply(this, arguments as any);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.filterOptions = [];
        
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(FilterPanelSection);
